import { useMemo } from 'react';
import { enumHelper, ANALYTICS_REPORT_TYPE, MONTH_TYPE, isSkeletonLoading } from 'shared';
import { FILTER_TYPE } from 'shared/ViewTable/AdvancedFilters';

export function useAnalyticsReportsBuildTable(inputs, t) {
  const reportTypesElements = useMemo(() => {
    return enumHelper.enumToFilter(ANALYTICS_REPORT_TYPE, t, 'analyticsReportTypes');
  }, [t]);

  const monthTypesElements = useMemo(() => {
    return enumHelper.enumToFilter(MONTH_TYPE, t, 'months', '-');
  }, [t]);

  const headCells = useMemo(() => {
    return [
      { id: 'name', numeric: false, disablePadding: false, label: t('properties.name'), ellipsis: true },
      {
        id: 'reportType',
        numeric: false,
        disablePadding: false,
        label: t('properties.reportType'),
        filterType: FILTER_TYPE.COMBO,
        filterValues: reportTypesElements
      },
      {
        id: 'year',
        numeric: false,
        disablePadding: false,
        label: t('properties.year')
      },
      {
        id: 'month',
        numeric: false,
        disablePadding: false,
        label: t('properties.month'),
        filterType: FILTER_TYPE.COMBO,
        filterValues: monthTypesElements,
        filterBy: 'month'
      }
    ];
  }, [t, reportTypesElements, monthTypesElements]);

  const rows = useMemo(() => {
    if (!inputs) {
      return [];
    }
    return inputs.items.map(report => ({
      name: report.name,
      reportType: isSkeletonLoading(report.reportType)
        ? report.reportType
        : reportTypesElements && reportTypesElements.filter(r => r.value === report.reportType.toString())[0]?.name,
      month: isSkeletonLoading(report.month)
        ? report.month
        : monthTypesElements && monthTypesElements.filter(r => r.value === report.month.toString())[0]?.name,
      year: report.year,
      reportFileUrl: report.reportFileUrl,
      reportFileName: report.reportFileName,
      id: report.id
    }));
  }, [inputs, reportTypesElements, monthTypesElements]);

  return { headCells, rows };
}
